(function ($, Drupal) {

  Drupal.behaviors.ichasRedirectionMessage = {
    attach(context) {
      const links = once('ichasRedirectionMessage',
        '.is-ichas-redirection', context);

      if (!links.length) {
        return;
      }

      links.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();

          const text = link.classList.contains('apply-form') ?
            Drupal.t('This course is processed by ICHAS for national applicants. You are now being redirected to the ICHAS website to apply.') :
            Drupal.t('You are being redirected to the ICHAS website to complete your application.');

          const message = document.createElement('div');
          message.classList.add('ichas-redirection-message');
          const content = document.createElement('div');
          content.classList.add('ichas-redirection-message__content');
          content.innerText = text;
          message.appendChild(content);

          document.body.appendChild(message);

          setTimeout(() => {
            window.location.href = link.href;
          }, 2500);

          setTimeout(() => {
            message.remove();
          }, 3000);
        });
      });
    },
  };

  })(jQuery, Drupal);
